import { useMutation } from "@apollo/client";
import { GridRowId } from "@mui/x-data-grid";
import { GET_PERSON_LOCATIONS } from "../components/StaffLocationTable";
import { UNASSIGN_PERSON_LOCATIONS_MUTATION, ASSIGN_PERSON_LOCATIONS_MUTATION } from "../../../features/graphql/mutation";
const DEFAULT_PAGE_SIZE = 10;
const usePersonLocationAssignment = (personId: string) => {
    const [assignPersons] = useMutation(ASSIGN_PERSON_LOCATIONS_MUTATION, {
        refetchQueries: [{
            query: GET_PERSON_LOCATIONS,
            variables: {
                personId: personId,
                query: "",
                first: DEFAULT_PAGE_SIZE
            }
            //TODO: PROBABLY A QUERY PERSON AS WELL
        }]
    })
    const [unassignPersons] = useMutation(UNASSIGN_PERSON_LOCATIONS_MUTATION, {
        refetchQueries: [{
            query: GET_PERSON_LOCATIONS,
            variables: {
                personId: personId,
                query: "",
                first: DEFAULT_PAGE_SIZE
            }
            //TODO: PROBABLY A QUERY PERSON AS WELL

        }]
    })
    const savePersons = async (assignments: GridRowId[], unassignments: GridRowId[]): Promise<number> => {

        let references = 0;
        // Exit early if there are no changes to be made
        if (assignments.length === 0 && unassignments.length === 0) {
            console.trace("Attempting to save changes but no assigment or unassigment IDs are provided");
            return 0;
        }

        if (assignments.length > 0) {
            if (process.env.NODE_ENV === "development")
                console.trace(`Attempting assigning persons to student ${personId}`, assignments);
            const response = await assignPersons({
                variables: {
                    personId,
                    locationIds: assignments
                }
            });

            // references = response.data?.assignLocationPersons?.totalStaff ?? 0;

            if (process.env.NODE_ENV === "development")
                console.trace(`Successfully assigned persons to student ${personId}`);

            if (response.errors?.length ?? 0 > 0)
                console.error("Student Assignment Failure", response.errors);
        }

        if (unassignments.length > 0) {
            if (process.env.NODE_ENV === "development")
                console.trace(`Attempting unassigning persons for student ${personId}`, assignments);
            console.log("the unassignments: ", unassignments)
            const response = await unassignPersons({
                variables: {
                    personId,
                    locationIds: unassignments
                }
            });

            // references = response.data?.unassignLocationPersons.totalStaff ?? 0;

            if (process.env.NODE_ENV === "development")
                console.trace(`Successfully unassigned persons to student ${personId}`);

            if (response.errors?.length ?? 0 > 0)
                console.error("Student Unassignment Failure", response.errors);
        }

        return references;
    }
    return { savePersons };
}

export default usePersonLocationAssignment